import { render, staticRenderFns } from "./IconMobile.vue?vue&type=template&id=becdce80&"
import script from "./IconMobile.vue?vue&type=script&lang=js&"
export * from "./IconMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports